// extracted by mini-css-extract-plugin
export default {"developmentBanner":"developmentBanner_developmentBanner__po0sS","stripes":"developmentBanner_stripes__Vb+Gh"};